<section *ngIf="show | async" class="document">
    <div class="document-header" *ngIf="!isMerged">
        <img [src]="'/assets/img/logo-console.svg' | ssrAsset" alt="Aptoide Connect logo" />
    </div>

    <div class="document-container">
        <ng-container *ngIf="loading | async">
            <app-loading-spinner [loadingMessage]="'common.loading-annex' | translate" align="horizontal"></app-loading-spinner>
        </ng-container>
        <ng-container *ngIf="!(loading | async)">
            <h4>Authorisation for the Distribution of Apps</h4>

            <div class="document">
                <p class="s">
                    <span class="s" *ngIf="hasAllUserInfo | async">{{ name | async }}, with principal place of business at {{ address | async }}</span>
                    <span class="s" *ngIf="!(hasAllUserInfo | async)">You</span>
                    hereby expressly declare{{ (hasAllUserInfo | async) ? "s" : "" }} that under the Distribution Agreement entered into with Aptoide S.A., a company with ID 509987184 and principal
                    place of business at Rua Soeiro Pereira Gomes, Lote 1, 3D, 1649-031 Lisboa, and its registered office at Rua Fernanda Seno n. 6, 7005-484, Évora, Portugal, Aptoide is authorised
                    to:
                </p>
                <br />

                <ol type="a">
                    <li class="s thin">Register an account in all app stores and distribution channels available through Aptoide Connect platform (https://connect.aptoide.com);</li>
                    <li class="s thin">Upload, distribute and manage the distribution of the Developer’s Apps in the above mentioned app stores;</li>
                    <li class="s thin">Implement, execute and manage promotional campaigns of the Developer’s Apps in Aptoide App Store and the above mentioned app stores.</li>
                </ol>
                <br />
                <br />
                <app-distribution-policy-signature></app-distribution-policy-signature>
            </div>
        </ng-container>
    </div>
</section>
